<template>
  <div class="panel-header panel-header-lg">
    <h6 style="margin-left: 30px; margin-bottom: 20px;" class="text-white"> {{$ml.get('client_statistics')}}
      <n-checkbox v-model="investigations">{{$ml.get('incl_investigation')}}</n-checkbox>
    </h6>
    <header-chart :height="200"
                  :data="newClientsMonthlyStats.values"
                  :labels="newClientsMonthlyStats.time"
                  :title="$ml.get('client_statistics')">
    </header-chart>
  </div>
</template>

<script>
  import HeaderChart from './HeaderChart'
  import {mapGetters} from 'vuex'
  import {Checkbox} from '../../../components'

  export default {
    name: 'overview-header',
    components: {
      HeaderChart,
      [Checkbox.name]: Checkbox
    },
    data(){
      return {
        investigations: true,
        newClientsMonthlyStats: {
          values: [],
          time: []
        }
      }
    },
    computed: {
      ...mapGetters(['clients'])
    },
    methods: {
      initialize() {
        let grouped = {};
        this.newClientsMonthlyStats = {
          values: [],
          time: []
        };
        const clients = this.clients.slice().reverse();
        clients.forEach(client => {
          if (client.ResellerId === this.account.reseller.id) {
            if (this.investigations || client.status === 'VERIFIED') {
              if (grouped[client.time.slice(0,7)]) grouped[client.time.slice(0,7)] += 1;
              else grouped[client.time.slice(0,7)] = 1;
            }
          }
        });

        Object.keys(grouped).forEach(key => {
          this.newClientsMonthlyStats.values.push(grouped[key]);
          this.newClientsMonthlyStats.time.push(this.$moment(key).format('MMMM - YYYY'));
        })
      }
    },
    mounted () {
      if (this.clients && this.clients.length > 0) this.initialize();
    },
    watch:{
      clients(nv) {
        if (nv && nv.length > 0) this.initialize();
      },
      investigations() {
        this.initialize();
      }
    }
  }
</script>

<style scoped>

</style>
